import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { usePrefersReducedMotion } from '@/lib/hooks';
import { Icon } from '@/components/Icons';

// Premium magnetic CTA. Variants: primary (teal), secondary (outline gold), light (on dark).
export const MagneticButton = ({
  as = 'link',
  to,
  href,
  onClick,
  children,
  variant = 'primary',
  className = '',
  withArrow = true,
  type,
  'data-testid': testId,
  'data-cursor': dataCursor,
}) => {
  const ref = useRef(null);
  const reduced = usePrefersReducedMotion();

  const handleMove = (e) => {
    if (reduced || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    ref.current.style.transform = `translate(${x * 0.18}px, ${y * 0.22}px)`;
  };
  const handleLeave = () => {
    if (ref.current) ref.current.style.transform = 'translate(0px, 0px)';
  };

  const base =
    'group relative inline-flex items-center justify-center gap-2.5 h-12 px-6 rounded-xl text-sm font-medium tracking-wide transition-colors duration-300 will-change-transform';
  const variants = {
    primary: 'bg-[#075B61] text-[#F6F5F1] hover:bg-[#0a6d74]',
    secondary: 'bg-transparent border border-[rgba(184,138,59,0.5)] hover:border-[rgba(184,138,59,0.95)]',
    light: 'bg-[#F6F5F1] text-[#20272A] hover:bg-white',
    gold: 'bg-[#B88A3B] text-[#20272A] hover:bg-[#c99a48]',
  };

  const inner = (
    <span
      ref={ref}
      className='inline-flex items-center gap-2.5 transition-transform duration-300 ease-out'
      style={{ transitionTimingFunction: 'cubic-bezier(0.22,1,0.36,1)' }}
    >
      {children}
      {withArrow && (
        <span className='transition-transform duration-300 group-hover:translate-x-1'>
          <Icon name='arrow' size={17} />
        </span>
      )}
    </span>
  );

  const props = {
    className: `${base} ${variants[variant]} ${className}`,
    onMouseMove: handleMove,
    onMouseLeave: handleLeave,
    'data-testid': testId,
    'data-cursor': dataCursor,
  };

  if (as === 'button') {
    return (
      <button type={type || 'button'} onClick={onClick} {...props}>
        {inner}
      </button>
    );
  }
  if (as === 'a') {
    return (
      <a href={href} onClick={onClick} {...props}>
        {inner}
      </a>
    );
  }
  return (
    <Link to={to} onClick={onClick} {...props}>
      {inner}
    </Link>
  );
};
